import React from "react";
import { motion } from "framer-motion";
import AnimatedSection from "../../WebDevelopmentPage/components/AnimatedSection";
import { hrmAdvantages } from "../hrmModulesData";

const HrmAdvantagesSection: React.FC = () => {
  return (
    <section className="hms-stats hrm-stats" aria-labelledby="hrm-advantages-title">
      <div className="container">
        <AnimatedSection className="wdev-section-head wdev-section-head--center">
          <h2
            id="hrm-advantages-title"
            className="wdev-section-head__title wdev-section-head__title--dark"
          >
            Key Advantages of Our HRM System
          </h2>
          <p className="hms-stats__lead">
            Streamline every HR process — from hiring and onboarding to payroll, performance, and
            compliance — in one integrated platform.
          </p>
        </AnimatedSection>

        <ul className="hms-stats__list">
          {hrmAdvantages.map((advantage, index) => (
            <motion.li
              key={advantage}
              className="hms-stats__item"
              initial={{ opacity: 0, x: -16 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: index * 0.06 }}
            >
              <span className="hms-stats__bullet" aria-hidden="true" />
              <p>{advantage}</p>
            </motion.li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default HrmAdvantagesSection;
